import { Checkbox, HTMLDivProps } from '@blueprintjs/core'
import * as React from 'react'
import './style.scss'

interface Props {
  checked?: boolean
  label: string
  index: number
}

export const Row = (props: Props & Pick<HTMLDivProps, 'onClick'>) => {
  return (
    <div className="location-multiselect-row" id={`row-${props.index}`} onClick={props.onClick}>
      <div className="index-label">{props.index + 1}</div>
      <Checkbox id={`checkbox-${props.index}`} checked={props.checked} />
      {props.label}
    </div>
  )
}
